/**
 * Canonical marketing stats — edit here; used across About, Achievements, etc.
 */
export const SITE_STATS = {
  appDownloads: '80K+',
  activeUsers: '25K+',
  verifiedProperties: '5000+',
  brokerageSaved: '₹50 Lakh+',
  whatsappGroups: '180+',
  instagramFollowers: '105K+',
  facebookFollowers: '90K+',
  youtubeViews: '13 Lakh+',
  whatsappCommunity: '20K+',
} as const
